import axios from 'axios'

export const fetchSailPackages = () => axios({ method: 'get', url: '/api/packages' })
